<template>
    <div class="modal_quaternary_full" v-show="mainStore.isModalQuaternaryVisible===true && mainStore.windowWidth>=960" style="background-image:url('/img/bg_buey.png');background-position: 50% 50%;background-repeat: no-repeat;background-size: cover;">
        <div class="container">
            <h1 class="return_full" @click="hideModal()">Volver al despiece</h1>
            <div class="container_in">
                <div class="image_container" style="width:50%;display: flex;justify-content: center;">
                <img :src="data.cortes[mainStore.currentCategory].img" usemap="#map" alt="">
                <map name="map">
            <area shape="circle" @click="openPart(item.split('/')[1])" :coords="item.split('/')[0]" href="#" alt=""  v-for="(item, index) in data.cortes[mainStore.currentCategory].map" v-bind:key="index">
        </map>
            </div>
                <div class="data_cortes">
                    <div class="selector">
            <span class="arrow_l" @click="goPrev()"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 0.75L0.999999 8L8.25 15.25" stroke="white" stroke-linecap="round"/>
</svg>
    </span>
            <h1 class="name">{{data.cortes[mainStore.currentCategory].producto}}</h1>
            <span class="arrow_r" @click="goNext()"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.25 15.25L8.5 8L1.25 0.75" stroke="white" stroke-linecap="round"/>
</svg>
    </span>
        </div>
                    <div class="description">
                {{data.cortes[mainStore.currentCategory].descripcion}}
            </div>
            <img src="/img/carne.png" alt="" style="width:100%;height: 50%;object-fit: cover;">
            <h2 class="title">FICHA TÉCNICA</h2>
            <hr>
            <ul>
                <li><span class="section_feature">Maduración: </span> <span class="feature_description">{{data.cortes[mainStore.currentCategory].maduracion}}</span></li>
                <li><span class="section_feature">Estado: </span> <span class="feature_description">{{data.cortes[mainStore.currentCategory].estado}}</span></li>
                <li><span class="section_feature">Peso Aprox: </span> <span class="feature_description">{{data.cortes[mainStore.currentCategory].peso_aprox}}</span></li>
                <li><span class="section_feature">Conservación: </span> <span class="feature_description">{{data.cortes[mainStore.currentCategory].conservacion}}</span></li>
            </ul>
            <h2 class="title">RECOMENDACIONES</h2>
            <hr>
            <p class="recomendaciones">{{data.cortes[mainStore.currentCategory].recomendaciones}}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="modal_quaternary" v-show="mainStore.isModalQuaternaryVisible===true && mainStore.windowWidth<960">
        <span class="return" @click="hideModal()">Volver al despiece</span>
        <div class="selector">
            <span class="arrow_l" @click="goPrev()"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 0.75L0.999999 8L8.25 15.25" stroke="white" stroke-linecap="round"/>
</svg>
    </span>
            <h1 class="name">{{data.cortes[mainStore.currentCategory].producto}}</h1>
            <span class="arrow_r" @click="goNext()"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.25 15.25L8.5 8L1.25 0.75" stroke="white" stroke-linecap="round"/>
</svg>
    </span>
        </div>
        <img :src="data.cortes[mainStore.currentCategory].img" usemap="#map" alt="">
        <model-viewer id="model-viewer" ar ar-modes="webxr scene-viewer quick-look"  :src="`./models/parts/${mainStore.currentCategory}_high.glb`"></model-viewer>
        <button class="view_ar" @click="openAR">VER EN AR</button>
        <map name="map">
            <area shape="circle" @click="openPart(item.split('/')[1])" :coords="item.split('/')[0]" href="#" alt=""  v-for="(item, index) in data.cortes[mainStore.currentCategory].map" v-bind:key="index">
        </map>
        <!--MAP GOES HERE-->
        <!--IMAGE CARNE?-->
        <div class="section">
            <div class="description">
                {{data.cortes[mainStore.currentCategory].descripcion}}
            </div>
            <img src="/img/carne.png" alt="" style="width:100%">
            <h2 class="title">FICHA TÉCNICA</h2>
            <hr>
            <ul>
                <li><span class="section_feature">Maduración: </span> <span class="feature_description">{{data.cortes[mainStore.currentCategory].maduracion}}</span></li>
                <li><span class="section_feature">Estado: </span> <span class="feature_description">{{data.cortes[mainStore.currentCategory].estado}}</span></li>
                <li><span class="section_feature">Peso Aprox: </span> <span class="feature_description">{{data.cortes[mainStore.currentCategory].peso_aprox}}</span></li>
                <li><span class="section_feature">Conservación: </span> <span class="feature_description">{{data.cortes[mainStore.currentCategory].conservacion}}</span></li>
            </ul>
            <h2 class="title">RECOMENDACIONES</h2>
            <hr>
            <p class="recomendaciones">{{data.cortes[mainStore.currentCategory].recomendaciones}}</p>
        </div>

        <div class="selector">
            <span class="arrow_l" @click="goPrev()"><svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 0.75L0.999999 8L8.25 15.25" stroke="white" stroke-linecap="round"/>
</svg>
    </span>
            <h1 class="name">{{data.cortes[mainStore.currentCategory].producto}}</h1>
            <span class="arrow_r" @click="goNext()"><svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.25 15.25L8.5 8L1.25 0.75" stroke="white" stroke-linecap="round"/>
</svg>
    </span>
        </div>
        <span class="return" @click="hideModal()">Volver al despiece</span>
        <br>
        <div class="go_up" @click="goTop()">
            <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="23.5" cy="23.5" r="23.5" fill="white"/>
<path d="M34 28L23.5 17L13 28" stroke="#BEA58B" stroke-width="2" stroke-linecap="round"/>
</svg>
        </div>
        <br>
    </div>
</template>

<script>
import { useMainStore } from '@/stores/mainStore';
import mainData from '@/data/cortes.json';
import allData from '@/data/cortes_all.json';
import { modalHide, modalShow } from '@/helpers/animations';
import '@google/model-viewer';


export default{
    name:'ModalQuaternary',
    setup(){
       const mainStore = useMainStore();
       return {mainStore} 
    },
    data: function(){
        return{
            data : mainData,
            allData: allData,
        }
    },
    methods:{
        modalShow: function(){
            modalShow(document.querySelector('.modal_quinquenary'),'quinquenary');
        },
        hideModal: function(){
            modalHide(document.querySelector('.modal_quaternary'),'quaternary')
        },
        openPart: function(part){
            console.log(part);
            this.mainStore.currentSpecific = allData.cortes[this.mainStore.currentCategory][part]
            console.log(allData.cortes[this.mainStore.currentCategory][part]);
            this.mainStore.isModalQuinquenaryVisible = true;
            modalShow(document.querySelector('.modal_quinquenary'),'quinquenary');
            modalShow(document.querySelector('.modal_quinquenary_full'),'quinquenary');
        },
        openAR: function(){
            const modelViewer = document.getElementById('model-viewer');
            modelViewer.activateAR();
        },
        
        goNext: function(){
            if(this.mainStore.currentCategory === 'pierna'){
                this.mainStore.currentCategory = 'chuletero';
            }else if(this.mainStore.currentCategory === 'chuletero'){
                this.mainStore.currentCategory = 'falda';
            }else if(this.mainStore.currentCategory === 'falda'){
                this.mainStore.currentCategory = 'delantero';
            }else if(this.mainStore.currentCategory === 'delantero'){
                this.mainStore.currentCategory = 'pierna';
            }
        },
        goPrev: function(){
            if(this.mainStore.currentCategory === 'pierna'){
                this.mainStore.currentCategory = 'delantero';
            }else if(this.mainStore.currentCategory === 'chuletero'){
                this.mainStore.currentCategory = 'pierna';
            }else if(this.mainStore.currentCategory === 'falda'){
                this.mainStore.currentCategory = 'chuletero';
            }else if(this.mainStore.currentCategory === 'delantero'){
                this.mainStore.currentCategory = 'falda';
            }
        },
        goTop: function(){
            document.querySelector('.modal_quaternary').scrollTo({top:0});
        }
    },
    mounted(){
       
    }
}
</script>

<style scoped>
.modal_quaternary{
    position: absolute;
    width: 100%;
    height: 100vh;
    top:0;
    right:0;
    z-index: 20;
    transform: scale(0);
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #2b282c;
    gap:30px;
    overflow: scroll; /*this is gonna cause a fuck ton of layout problems */
}

.data_cortes{
    width: 50%;
    height:100%;
    overflow-y: scroll;
    padding-top: 20px;
    padding-right: 25px;
    padding-bottom: 25px;
}

.modal_quaternary_full{
    position: absolute;
    width: 100%;
    height: 100vh;
    top:0;
    right:0;
    z-index: 20;
    transform: scale(0);
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #2b282c;
    gap:10px;
}

.return_full{
    color:#fff;
    text-decoration: underline;
    font-family: 'garamond';
    font-size: 18px;
    font-weight: 400;
}

.container{
  background: rgba(0,0,0,.8);
  top:0;
  left: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.container_in{
    background: #2B282C;
  width: 80%;
  height:80%;
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center
}
.comprar{
    background-color: #967B60;
    font-family: 'Cervo';
    color: #fff;
    height: 48px;
    width: 96px;
    border: none;
    font-size: 18px;
    outline: none;
}

.modal_quaternary>*{
    flex-shrink: 0;
}

.name{
    color:#BEA58B;
    font-family: 'garamond';
    font-weight: 400;
}


::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
.return{
    color:#fff;
    text-decoration: underline;
    margin-top: 20px;
    font-family: 'garamond';
    font-size: 18px;
}

.title{
    font-family:'cervo';
    color:#fff;
    font-weight: 400;
    margin-top:45px;
}

.selector{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 240px;
    justify-content: space-between;
    margin-bottom: 35px;
    margin-top:15px;
}
.section_feature{
    font-family: 'garamond';
    font-weight: 600;
    color:#fff;
    font-size: 18px;
}

.section{
    padding-left:25px;
    padding-right: 25px;
}
.feature_description{
    font-family: 'garamond';
    font-weight: 400;
    color:#fff;
    margin-left: 2.5px;
    font-size: 18px;
}

.recomendaciones{
    font-family: 'garamond';
    font-weight: 400;
    color: #fff;
    margin-bottom: 25px;
    font-size: 18px;
}

ul>li{list-style: none;}

hr{
    border: 1px solid #BEA58B;
    margin: 5px 0 10px 0;
}

.view_ar{
    border: 1px solid #fff;
    width:86px;
    height: 40px;
    background-color: transparent;
    font-family: 'cervo';
    font-size:16px;
    color:#fff;
    margin-top:15px;
}

.description{
    font-family: 'garamond';
    font-weight: 400;
    color: #fff;
    margin-bottom: 45px;
    font-size: 18px;
}

model-viewer{
    width: 320px;
    height:320px;
    display: none;
}

</style>